<template>

  <v-img
    class = "ma-2"
    :max-height="height"
    :max-width="width"
    lazy-src="@/assets/imagenotfound.png"
    :key="componentKey"
    :src="imageurlItem"
    :aspect-ratio="ratio"
  >
    <ImageForm
      ref="updateForm"
      :item="item"
      v-if="edit"
    />
      <v-btn v-if="imageurlItem && download"
        color="secondary"
        small
        absolute
        bottom
        right
        @click="downloadItem()"
      >
        <v-icon>mdi-download-circle</v-icon>
      </v-btn>
  </v-img>
</template>

<script>
import FileMixin from '../mixins/FileMixin';
import ImageForm from './ImageForm.vue';

export default {
  mixins: [FileMixin],
  components: {
      ImageForm
  },
  data: () => ({
  }),
  props: {
    item: {
      type: Object,
      required: true
    },
    filter: {
      type: String,
      required: true
    },
    edit: {
      type: Boolean,
      required: true
    },
    height: {
      type: String,
      required: false,
      default: "250"
    },
    width: {
      type: String,
      required: false,
      default: "250"
    },
    ratio: {
      type: String,
      required: false,
      default: "1"
    },
    download: {
      type: Boolean,
      required: false,
      default: true
    },
  },


};
</script>
